import { useCreateWorkspaceMember } from "./useCreateWorkspaceMember";

import { WorkspaceMember } from "@/types/workspaceMembers";
import { persistActiveWorkspaceId } from "@/utils/activeWorkspace";

export const useAcceptAllInvites = () => {
  const { mutateAsync: createWorkspaceMember } = useCreateWorkspaceMember({
    shouldNavigate: false,
  });

  const acceptAllInvites = async (
    invite_ids: number[],
    access_token: string,
  ): Promise<WorkspaceMember[]> => {
    const promises = invite_ids.map(invite_id =>
      createWorkspaceMember({
        workspace_invite_id: invite_id,
        access_token: access_token,
      }),
    );

    const results = await Promise.all(promises);

    const lastWorkspace = results[results.length - 1];
    if (lastWorkspace?.workspace_id) {
      persistActiveWorkspaceId(lastWorkspace.workspace_id);
    }

    return results;
  };

  return { acceptAllInvites };
};
